import { Component } from '@angular/core';

@Component({
  selector: 'app-home',
  template: '',
})
export class HomeComponent {}
